import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import React, { Fragment, useState } from 'react';

interface CarouselFeedProps {
  items: any[];
  autoPlay?: boolean;
  interval?: number;
}

export const CarouselFeed: React.FC<CarouselFeedProps> = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === items.length - 1 ? 0 : prev + 1));
  };

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1));
  };

  if (!items.length) return null;

  return (
    <div className="carousel-container">
      <div className="carousel-viewport">
        <div
          className="carousel-track"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {items.map((item) => {
            const img_small = item.contentUris.find((item: any) => item.identifier === 'THUMBNAIL_TALL')?.uri;
            const img_large = item.contentUris.find((item: any) => item.identifier === 'THUMBNAIL_WIDE')?.uri;
            return <Fragment key={item.identifier}>
              <a className="carousel-slide" href={item.actionUri} title={item.title}  >
                <picture >
                  <source media="(max-width:576px)" srcSet={img_small} />
                  <img src={img_large} alt={item.title} />
                </picture>
                <span className='btn btn-primary' >{t("button_discover_text")} <FontAwesomeIcon icon={faAngleRight} /></span>
              </a>
            </Fragment>
          })}
        </div>
      </div>

      <button className="nav-btn prev" onClick={goToPrev} aria-label="Previous">❮</button>
      <button className="nav-btn next" onClick={goToNext} aria-label="Next">❯</button>

      <div className="dots-container">
        {items.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </div>
  );
};
